(function($){
    $(window).scroll(function(){
        if ($(this).scrollTop() > 150) {
            if ($('header.fixed').html() == '') {
                // $('header.fixed').html($('header.static').html());
            }
            $('header.fixed').slideDown(500);
        } else {
            $('header.fixed').slideUp(500);
        }
    });
})(jQuery)